<template>
    <a :class="{'is-active': active}" @click.stop="click">
        {{label}}
    </a>
</template>
<script>
    import Vue from 'vue';
    import {Component, Prop} from 'vue-property-decorator';
    import {GET_LANGUAGE, SET_LANGUAGE} from '../../store/modules/locale';

    @Component
    export default class LocaleButton extends Vue {
        @Prop({type: String, required: true})
        language;

        get active() {
            return this.$store.getters[GET_LANGUAGE] === this.language;
        }

        get label() {
            return this.language.toUpperCase();
        }

        click() {
            this.$store.dispatch(SET_LANGUAGE, this.language);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/LocaleButton.vue